if (!customElements.get('curated-faq')) {
  customElements.define('curated-faq', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('.deli-faq-item-trigger');
        if (!trigger || trigger.closest('curated-faq') !== this) return;

        const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.deli-faq-item-trigger').forEach((button) => {
          const open = button === trigger && shouldOpen;
          const item = button.closest('.deli-faq-item');
          const body = item.querySelector('.deli-faq-item-body');
          item.classList.toggle('is-open', open);
          button.setAttribute('aria-expanded', String(open));
          body.setAttribute('aria-hidden', String(!open));
          body.toggleAttribute('inert', !open);
        });
      });
    }
  });
}
